import { useEffect, useRef } from "react";
import "../App.css";

const CustomCursor = () => {
    const cursorRef = useRef(null);

    useEffect(() => {
        const moveCursor = (e) => {
            if (cursorRef.current) {
                cursorRef.current.style.left = `${e.clientX}px`;
                cursorRef.current.style.top = `${e.clientY}px`;
            }
        };

        document.addEventListener("mousemove", moveCursor);

        // Cleanup
        return () => {
            document.removeEventListener("mousemove", moveCursor);
        };
    }, []);

    return <div ref={cursorRef} className="custom-cursor"></div>;
};

export default CustomCursor;
